import React from 'react';
import { Link } from 'react-router-dom';

import styles from './SimpleCta.module.postcss';

function SimpleCta({ text, link, linkTitle, linkIsExternal }) {
  return (
    <div className={styles.SimpleCta + ' u-textCenter'}>
      <p className='u-strong'>{ text }</p>
      { linkIsExternal ?
        <a className='Button Button--outlined' href={link}>{ linkTitle }</a>
      :
        <Link className='Button Button--outlined' to={link}>{ linkTitle }</Link>
      }
    </div>
  );
}

export default SimpleCta;
